import { asset } from "./assets";
import styles from "./MadMonkey.module.scss";

export const Arrow = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M5 12h14M13 6l6 6-6 6" />
	</svg>
);

/** A country's round flag; `size` overrides the 18px default. */
export const Flag = ({ cc, size }: { cc: string; size?: number }) => (
	<img
		className={styles.flag}
		src={asset(`img/flag-${cc}.png`)}
		alt=""
		width={size ?? 18}
		height={size ?? 18}
		style={size ? { width: size, height: size } : undefined}
	/>
);

/** The Stippl "S" mark */
export const StipplMark = ({ fill = "#13c892" }: { fill?: string }) => (
	<svg viewBox="0 0 81 108" fill={fill} aria-hidden="true">
		<path d="M17.3912 99.1864C14.9217 99.1864 12.9613 101.159 13.0092 103.593C13.0589 106.025 15.0991 108 17.5668 108C20.0363 108 21.9967 106.025 21.9488 103.593C21.8991 101.159 19.8589 99.1864 17.3912 99.1864ZM65.3336 33.3614C76.1235 30.4927 80.4221 24.1043 80.431 16.7419C80.4434 6.75566 72.3519 0 59.0871 0C38.1939 0 0 22.4846 0 43.1187C0 59.3036 21.0387 64.5548 35.3004 67.8972C49.5639 71.2377 60.588 74.2732 60.588 78.2187C60.588 82.1625 48.0081 91.0523 27.7464 97.4815C25.575 98.2036 24.3065 100.144 24.9097 101.816C25.5147 103.487 27.7145 104.079 29.9356 103.533C38.3749 101.452 78.201 92.3474 78.201 74.4204C78.201 56.4935 35.2862 49.1612 35.2862 45.9005C35.2862 42.5528 56.6017 35.6819 65.3336 33.3614Z" />
	</svg>
);

export const MM_MONKEY = asset("img/mm-monkey.png");
